<template>
  <!-- Start Wrapper Main -->
  <div class="wrapper__main checkout-page">
    <!-- Start Heading page -->
    <div class="heading-page">
      <div class="menu-title">
        <div class="container">
          <div class="menu-items row">
            <div class="col-xs-12">
              <ul>
                <li><router-link to="/"> Home</router-link> <span>› </span></li>
                <li><strong>Checkout</strong></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="page-title">
        <h2>Checkout</h2>
      </div>
    </div>
    <!-- End Heading page -->


    <!-- Start Checkout Products Table -->
    <div class="container" v-if="cartItems.length">
      <div class="checkout-products table-responsive">
        <form action="#">
          <div>
            <table class="page-table data-table cart-table table-striped">
              <colgroup>
                <col width="1" />
                <col />
                <col width="1" />
                <col width="1" />
                <col width="1" />
                <col width="1" />
                <col width="1" />
              </colgroup>
              <thead>
                <tr>
                  <th rowspan="1">&nbsp;</th>
                  <th rowspan="1">
                    <span class="fixed-br">Product Name</span>
                  </th>
                  <th rowspan="1"></th>
                  <th colspan="1">
                    <span class="fixed-br">Unit Price</span>
                  </th>
                  <!-- <th rowspan="1">Qty</th>
                  <th colspan="1">Subtotal</th> -->
                  <th rowspan="1">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in cartItems" :key="item.id" class="checkout-product-item">
                  <td class="image">
                    <a href="#!" class="product-image">
                      <img :src="item.photo" :alt="item.Product_name" width="75" />
                    </a>
                  </td>
                  <td>
                    <h2 class="product-name">
                      <a href="#!">{{item.Product_name}}</a>
                    </h2>
                  </td>
                  <td>
                    <!-- <a href="#!" class="edit-btn"></a> -->
                  </td>
                  <td>
                    <span class="cart-price">
                      <span class="price">{{item.price}}</span>
                    </span>
                  </td>

                  <td>
                    <a href="#!" class="button remove-item" @click="deleteItem(item.id)"></a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-footer">
                  <td colspan="50">
                    <a href="#cart-payment">
                      <button type="button" class="btn-continue" onclick="continueShop();">
                        <span><span>Continue Shopping</span></span>
                      </button>
                    </a>
                    <!-- <button type="button" class="btn-update">
                      <span><span>Update Cart</span></span>
                    </button> -->
                    <button type="button" class="btn-empty" @click="emptyCart">
                      <span><span>Clear Cart</span></span>
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </form>
      </div>
    </div>

    <div class="" v-if="!cartItems.length">
      <p class="text-center p-2 h3">there are no items</p>
    </div>
    <!-- End Checkout Products Table -->

    <!-- Start Cart Payment Section -->
    <div class="container">
      <div class="cart-payment" id="cart-payment" v-if="cartItems.length">
        <div class="row">
          <div class="col-sm-4">
            <div class="shipping">
              <h3>Estimate Shipping and Tax</h3>
              <div class="shipping-form">
                <form action="#" class="shipping-info-form">
                  <p>Enter your phone and destination to get a shipping estimate.</p>
                  <small class="alert-warning">If you didn't fill out the fields below, we will use the phone and the address from your profile</small>
                  <ul class="form-list">
                    <li>
                      <label class="required"><em>* </em>Phone </label>
                      <div class="input-box">
                        <input class="form-control" v-model="shippingInfo.client_phone" />
                      </div>
                    </li>
                    <li>
                      <label class="required"><em>* </em>Address </label>
                      <div class="input-box">
                        <textarea class="form-control" v-model="shippingInfo.new_address" rows="8" cols="80"></textarea>
                      </div>
                    </li>
                    <!-- <li>
                      <label for="postcode">Zip/Postal Code</label>
                      <div class="input-box">
                        <input class="input-text" type="text" />
                      </div>
                    </li> -->
                  </ul>
                  <!-- <div class="btn-get-quote">
                    <button type="button" class="get-quote">
                      <span>Get a Quote</span>
                    </button>
                  </div> -->
                </form>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="discount">
              <h3>Discount Codes</h3>
              <form action="#" class="discount-coupon-form">
                <label>Enter your coupon code if you have one.</label>
                <input type="text" class="input-text coupon-code" />
                <button type="button" class="coupon" onclick="addCoupon();">
                  <span>Apply Coupon</span>
                </button>
              </form>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="totals">
              <h3>Shopping Cart Total</h3>
              <div class="inner">
                <table class="table shopping-cart-totals-table">
                  <colgroup>
                    <col />
                    <col width="1" />
                  </colgroup>
                  <tfoot>
                    <tr>
                      <td colspan="1">
                        <strong>Grand Total</strong>
                      </td>
                      <td>
                        <strong><span class="price">${{ cartItems.reduce((a,b)=> ({price: +a.price + +b.price})).price }}</span></strong>
                      </td>
                    </tr>
                  </tfoot>
                  <tbody>
                    <tr>
                      <td colspan="1">Subtotal</td>
                      <td>
                        <span class="price">${{ cartItems.reduce((a,b)=> ({price: +a.price + +b.price})).price }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ul class="checkout">
                  <li>
                    <button @click="checkout" type="button" class="btn-checkout">
                      <span >Proceed to Checkout</span>
                    </button>
                  </li>
                  <br />
                  <li>
                    <a href="#!">Checkout with Multiple Addresses</a>
                  </li>
                  <br />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Cart Payment Section -->
  </div>
  <!-- End Wrapper Main -->
</template>
<script>
import { mapMutations } from 'vuex';
import Swal from 'sweetalert2';

export default{
  data(){
    return{
      shippingInfo:{
        client_phone: null,
        new_address: null
      }
    }
  },
  computed:{
    api(){
      return this.$store.state.api;
    },
    cartItems(){
      return this.$store.state.shopCart;
    }
  },
  components:{

  },

  mounted(){

  },
  methods:{
    ...mapMutations(["removeFromCart", "emptyTheCart"]),
    deleteItem(id){
      this.removeFromCart(id)
    },
    checkout(){
      let cartItemsIds = this.cartItems.map((item, i) => 'product_ids[' + i + ']=' + item.id + '&').join('');
      fetch(`${this.api}/cart/add?client_id=${localStorage.getItem('care_user_id')}&client_name=${localStorage.getItem('care_user_name')}&client_phone=${this.shippingInfo.client_phone}&new_address=${this.shippingInfo.new_address}&${cartItemsIds}payment_method=cash&status=0&check=1&Payment_Date=${Date.now()}`,{
        method: 'POST',
        headers:{
          "Authorization": localStorage.getItem('care_user_auth_token')
        }
      })
      .then(res => res.json())
      .then(data => {
        if(data.success){
          this.emptyTheCart();
          Swal.fire({
            title: 'Success!',
            text: 'Your order sent successfully',
            icon: 'success',
            confirmButtonText: 'OK.'
          })
        }
      })
    },
    emptyCart(){
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.emptyTheCart();
          Swal.fire(
            'Deleted!',
            'Your cart is empty now.',
            'success'
          )
        }
      })
    }
  }
}
</script>
